import { BaseService } from "../BaseService";
import {
  Tenant,
  UpdateTenantRequest,
  TenantQuota,
  TenantPlan,
  GoogleOAuthSettings,
} from "@/types/breeze/Tenant";

export class TenantService extends BaseService {
  public async getTenantById(tenantId: number): Promise<Tenant> {
    return this.getRequest(`/org/${tenantId}`, false);
  }

  public async updateTenant(
    tenantId: number,
    tenant: UpdateTenantRequest,
  ): Promise<Tenant> {
    return this.putRequest(
      `/org/${tenantId}`,
      tenant,
      "Account updated",
      false,
    );
  }

  public async getTenantStorageUsage(tenantId: number): Promise<TenantQuota> {
    return this.getRequest(`/org/${tenantId}/storage`, false);
  }

  public async getPlan(): Promise<TenantPlan> {
    return this.getRequest("/plan");
  }

  public async getTenantGoogleOAuthSettings(
    tenantId: number,
  ): Promise<GoogleOAuthSettings> {
    return this.getRequest(`/org/${tenantId}/integrations/oauth/google`, false);
  }

  public async updateTenantGoogleOAuthSettings(
    tenantId: number,
    settings: GoogleOAuthSettings,
  ): Promise<GoogleOAuthSettings> {
    return this.putRequest(
      `/org/${tenantId}/integrations/oauth/google`,
      settings,
      "Google OAuth settings updated",
      false,
    );
  }
}

export const tenantService = new TenantService();
